import axios from 'axios'

import { type CoreStoreDomainStatus } from '@flecto/types'

/**
 * Get an existing (or not) domain config and details, through a local proxy.
 *
 * @endpoint GET /api/stores/domains/status
 * @scope saas (local proxy)
 */
export async function getStoreCustomDomainStatus(domain: string): Promise<CoreStoreDomainStatus> {
  const res = await axios.get(`/api/stores/domains/status?domain=${domain}`)

  return res.data
}
